module.exports = __webpack_public_path__ + "static/media/HDFCLIFE.aeac64cf.txt";